"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickType = void 0;
var PickType;
(function (PickType) {
    PickType["BlindPick"] = "BLIND_PICK";
    PickType["DraftMode"] = "DRAFT_MODE";
    PickType["AllRandom"] = "ALL_RANDOM";
    PickType["TournamentDraft"] = "TOURNAMENT_DRAFT";
})(PickType = exports.PickType || (exports.PickType = {}));
//# sourceMappingURL=pick-type.js.map